<template>
  <v-card color="rgb(255, 255, 255, 0.2)" class="flexcard" height="100%">
    <v-img contain :src="movie.poster" aspect-ratio="1"></v-img>
    <div class="overlay">
      <div class="text">{{ movie.overview }}</div>
    </div>
    <v-card-title primary-title>
      <div>
        <h2>{{ movie.title }}</h2>
        <div>Year: {{ movie.year }}</div>
        <v-progress-circular
          style="{'z-index:-1' }"
          size="50"
          color="purple darken-4"
          :value="movie.rating"
          >{{ movie.rating / 10 }}</v-progress-circular
        >
      </div>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  props: {
    movie: Object,
  },
  onMounted() {
    console.log("here");
  },
};
</script>

<style scoped>
.v-progress-circular {
  z-index: -1;
}
.v-card__title {
  word-break: normal; /* maybe !important  */
}
</style>